import { render, staticRenderFns } from "./specialDetail.vue?vue&type=template&id=1148e3b6&scoped=true"
import script from "./specialDetail.vue?vue&type=script&lang=js"
export * from "./specialDetail.vue?vue&type=script&lang=js"
import style0 from "./specialDetail.vue?vue&type=style&index=0&id=1148e3b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1148e3b6",
  null
  
)

export default component.exports